bovoApp.factory('Marketplace', ['$http', function ($http) {
    var base = '/admin/marketplace';

    return {
        // ====================
        // Integrations
        // ====================
        integrations: function (params) {
            return $http.get(base + '/integrations', { params: params || {} });
        },
        integration: function (id) {
            return $http.get(base + '/integrations/' + id);
        },
        providers: function () {
            return $http.get(base + '/integrations/providers');
        },
        saveIntegration: function (data) {
            return $http.post(base + '/integrations', data);
        },
        updateIntegration: function (id, data) {
            return $http.put(base + '/integrations/' + id, data);
        },
        deleteIntegration: function (id) {
            return $http.delete(base + '/integrations/' + id);
        },
        testIntegration: function (id) {
            return $http.post(base + '/integrations/' + id + '/test', {});
        },
        triggerPull: function (id) {
            return $http.post(base + '/integrations/' + id + '/trigger/pull', {});
        },
        triggerSync: function (id) {
            return $http.post(base + '/integrations/' + id + '/trigger/sync', {});
        },
        triggerClaims: function (id) {
            return $http.post(base + '/integrations/' + id + '/trigger/claims', {});
        },

        // ====================
        // Status Mappings
        // ====================
        statusMappings: function (params) {
            return $http.get(base + '/status-mappings', { params: params || {} });
        },
        saveStatusMapping: function (data) {
            return $http.post(base + '/status-mappings', data);
        },
        updateStatusMapping: function (id, data) {
            return $http.put(base + '/status-mappings/' + id, data);
        },
        deleteStatusMapping: function (id) {
            return $http.delete(base + '/status-mappings/' + id);
        },
        missingStatuses: function (params) {
            return $http.get(base + '/status-mappings/missing-statuses', { params: params || {} });
        },
        workSteps: function () {
            return $http.get(base + '/status-mappings/work-steps');
        },

        // ====================
        // Order Maps
        // ====================
        orderMaps: function (params) {
            return $http.get(base + '/orders', { params: params || {} });
        },
        orderMap: function (id) {
            return $http.get(base + '/orders/' + id);
        },
        rematch: function (id) {
            return $http.post(base + '/orders/' + id + '/rematch', {});
        },
        manualMatch: function (id, orderId) {
            return $http.post(base + '/orders/' + id + '/manual-match', { order_id: orderId });
        }
    };
}]);
